import React from "react";
import { brand } from "@/theme/themeTokens";

export function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal-700 text-white font-heading font-extrabold text-lg shadow-sm">
        {brand.wordmarkMark}
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className="font-heading font-extrabold text-slate-900 text-base tracking-tight">
            {brand.name}
          </div>
        </div>
      )}
    </div>
  );
}
